/** Foundation · Timesheet — totali sempre visibili durante la compilazione. */
import React from "react";
import { formatDuration, useDurationFormat, DurationFormatBadge } from "@/foundation/duration";

const Kpi = ({ label, value, tone = "", testid, big }) => (
  <div className="flex items-baseline gap-2">
    <span className="text-[10px] uppercase tracking-[0.14em] text-suite-neutral-500">{label}</span>
    <span className={`font-mono ${big ? "text-lg font-semibold" : "text-sm"} ${tone}`} data-testid={testid}>{value}</span>
  </div>
);

export function TimesheetTotalsBar({ totals, onJumpToIssue }) {
  const fmt = useDurationFormat();
  const d = totals.difference;
  return (
    <div className="sticky bottom-0 z-30 flex flex-wrap items-center justify-between gap-x-6 gap-y-2 rounded-lg border border-suite-neutral-800 bg-suite-neutral-900 px-4 py-2.5 text-white shadow-lg" data-testid="timesheet-totals-bar">
      <div className="flex flex-wrap items-center gap-x-6 gap-y-1">
        <Kpi label="Lavorate" big value={formatDuration(totals.worked / 60, fmt)} testid="ts-total-worked" />
        <Kpi label="Teoriche" value={formatDuration(totals.theoretical / 60, fmt)} testid="ts-total-theoretical" />
        <Kpi label="Differenza" big value={formatDuration(d / 60, fmt, { signed: true })} tone={d > 0 ? "text-emerald-300" : d < 0 ? "text-red-300" : ""} testid="ts-total-diff" />
        {!!totals.justified && <Kpi label="Giustificate" value={formatDuration(totals.justified / 60, fmt)} tone="text-amber-200" testid="ts-total-justified" />}
      </div>
      <div className="flex items-center gap-2 text-xs">
        {totals.errors > 0 && <button type="button" onClick={() => onJumpToIssue?.("error")} className="rounded-full bg-red-500/20 px-2.5 py-0.5 text-red-200 hover:bg-red-500/30" data-testid="timesheet-error-count">{totals.errors} da correggere</button>}
        {totals.warnings > 0 && <button type="button" onClick={() => onJumpToIssue?.("warning")} className="rounded-full bg-amber-500/20 px-2.5 py-0.5 text-amber-200 hover:bg-amber-500/30" data-testid="timesheet-warning-count">{totals.warnings} avvisi</button>}
        {!totals.errors && !totals.warnings && <span className="text-emerald-300" data-testid="timesheet-no-issues">Nessuna anomalia</span>}
        <DurationFormatBadge data-testid="timesheet-format-badge" />
      </div>
    </div>
  );
}

export default TimesheetTotalsBar;
